import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 3,
        backgroundColor: 'primary.main',
        color: 'white',
        textAlign: 'center',
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 1000, // keep it above content
      }}
    >
      <Typography variant="body2" sx={{ fontSize: '0.875rem' , color: 'white'}}>
        © {new Date().getFullYear()} Easy Software Pvt. Ltd | All Rights Reserved
      </Typography>
    </Box>
  );
}

export default Footer;
